import { PipesModule } from './../../../common/pipes/pipes.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { CommonModule } from '@angular/common';
import { AutosizeModule } from 'ngx-autosize';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    MissingTranslationHandler,
    TranslateModule,
} from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE,
} from '@angular/material/core';
import { DirectivesModule } from '../../../common/directives/directives.module';
import { getLanguage } from '@/common/utils/strings/path.utils';
import { ButtonComponent } from './button/button.component';
import { HeaderComponent } from './header/header/header.component';
import { MenuMobileComponent } from './menu-mobile/menu-mobile.component';
import { FiltersComponent } from './filters/filters.component';
import { CardVehicleComponent } from './card-vehicle/card-vehicle.component';
import { InputComponent } from './input/input.component';
import { FormControlFeedbackComponent } from './form-control-feedback/form-control-feedback.component';
import { SwalComponent, SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { PlaceholderComponent } from './placeholder/placeholder.component';
import { ApiMissingTranslationHandler } from '@/core/translations/api.missing.translation.handler';
import { SsrService } from '@/common/services/ssr/ssr.service';
import {
    NgbDatepickerModule,
    NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [
        ButtonComponent,
        HeaderComponent,
        MenuMobileComponent,
        FiltersComponent,
        CardVehicleComponent,
        InputComponent,
        FormControlFeedbackComponent,
        PlaceholderComponent,
    ],
    exports: [
        ButtonComponent,
        HeaderComponent,
        MenuMobileComponent,
        FiltersComponent,
        CardVehicleComponent,
        InputComponent,
        FormControlFeedbackComponent,
        PlaceholderComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        NgxMaskDirective,
        NgxMaskPipe,
        AutosizeModule,
        ReactiveFormsModule,
        FormsModule,
        TranslateModule.forChild({
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: ApiMissingTranslationHandler,
                deps: [SsrService],
            },
            extend: true,
        }),
        NgSelectModule,
        PipesModule,
        MatDatepickerModule,
        MatIconModule,
        DirectivesModule,
        SweetAlert2Module,
        NgbDatepickerModule,
        NgbTooltipModule,
    ],
    providers: [
        provideNgxMask(),
        {
            provide: DateAdapter,
            deps: [MAT_DATE_LOCALE],
            useValue: new LuxonDateAdapter(getLanguage(), {
                useUtc: false,
                firstDayOfWeek: 1,
                defaultOutputCalendar: 'gregory',
            }),
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'D',
                },
                display: {
                    dateInput: 'dd LLLL yyyy',
                    monthYearLabel: 'LLL yyyy',
                    dateA11yLabel: 'DD',
                    monthYearA11yLabel: 'LLLL yyyy',
                },
            },
        },
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UiModule {}
